window.onWizzyScriptLoaded = function () {

  // Replacing default template
  replaceTemplate("wizzy-search-results-product");
  // replaceTemplate("wizzy-search-results");
  // replaceTemplate("wizzy-search-empty-results");
  replaceTemplate("wizzy-search-wrapper");
  replaceTemplate("wizzy-autocomplete-topproducts");
  replaceTemplate("wizzy-autocomplete-suggestions");

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (payload) {
      window.wizzyConfig.search.configs.general.minQueryLength = 1;
      if(window.document.documentElement.clientWidth < 768){
        payload.common.lazyDOMConfig.searchInputIdentifiers = [
          {
            'dom': '.wizzy-search-input-mobile',
            'type': 'text'
          }
         ];
      }else {
         payload.common.lazyDOMConfig.searchInputIdentifiers = [
          {
            'dom': '.wizzy-search-input',
            'type': 'text'
          }
         ];
      }
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (payload) {
      window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = true;
      window.wizzyConfig.common.lazyDOMConfig.contentDOMIdentifiers.push("#main");
      window.wizzyConfig.search.configs.general.minQueryLength = 1;

       // payload.common.lazyDOMConfig.searchInputIdentifiers.push(
       //    {
       //      'dom': '.header-searchbar.mobile input',
       //      'type': 'text'
       //    },
       //    {
       //      'dom': "header [name=\"q\"]",
       //      'type': "text"
       //    }
       //   );

      if(window.document.documentElement.clientWidth < 768){
        payload.common.lazyDOMConfig.searchInputIdentifiers = [
          {
            'dom': '.wizzy-search-input-mobile',
            'type': 'text'
          }
         ];
      }else {
         payload.common.lazyDOMConfig.searchInputIdentifiers = [
          {
            'dom': '.wizzy-search-input',
            'type': 'text'
          }
         ];
      }

      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (payload) {
      // console.log(payload, " <== AFTER_PRODUCTS_TRANSFORMED")
      payload.forEach(product => {
        product.handle = "";
        product.subTitle = "";
        product.newLaunch = false;
        if(product.attributes){
          product.attributes.forEach(attribute => {
            if(attribute.id === "product_handle"){
              if(attribute.values[0].value[0]){
                product.handle = attribute.values[0].value[0];
              }
            }
            if(attribute.id === "product_product_grid_sub_title_my_fields"){
              if(attribute.values[0].value[0]){
                product.subTitle = attribute.values[0].value[0];
              }
            }
            if(attribute.id === "product_custom_tag_my_fields"){
              if(attribute.values[0].value[0] && (attribute.values[0].value[0] === "New Launch" || attribute.values[0].value[0] === "New Launch ")){
                product.newLaunch = true;
              }
            }
          })
        }
      })

      // payload.forEach(product => {
      //   product.reviewAvailable = false;
      //   product.avgRatings = "";
      //   product.totalReviews = "";
      //   if(product.attributes){
      //     product.attributes.forEach(attribute => {
      //       if(attribute.id === "product_badge_judgeme"){
      //         if(attribute.values[0].value[0]){
      //           product.reviewAvailable = true;
      //           var ele = attribute.values[0].value[0];

      //           var productReview = window.document.createElement("div");
      //           productReview.innerHTML = attribute.values[0].value[0];

      //           var badge = productReview.querySelector('.jdgm-prev-badge');
      //           var averageRating = badge.getAttribute("data-average-rating");
      //           var ratingNumbers = badge.getAttribute("data-number-of-reviews");
      //           if(averageRating > 0 && ratingNumbers){
      //             product.reviewAvailable = true;
      //             product.avgRatings = averageRating;
      //             product.totalReviews = ratingNumbers;
      //             console.log(product.avgRatings, product.totalReviews,"productReview");
      //           }
      //         }
      //       }
      //     })
      //   }
      // })


      payload.forEach(product => {
        product.reviewAvailable = false;
        product.avgRatings = "";
        product.totalReviews = "";
        product.renderedReviewElement = "";
      
        if (product.attributes) {
          product.attributes.forEach(attribute => {
            if (attribute.id === "product_badge_judgeme") {
              if (attribute.values[0].value[0]) {
      
                const htmlString = attribute.values[0].value[0];
                const container = document.createElement("div");
                container.innerHTML = htmlString;
      
                // Extract data (you can adapt these if the data source changes)
                var averageRating = parseFloat(
                  container.querySelector('.jdgm-prev-badge')?.getAttribute("data-average-rating") || 0
                );
                var ratingNumbers = container.querySelector('.jdgm-prev-badge')?.getAttribute("data-number-of-reviews") || "0";

                if(averageRating > 0){
                  product.reviewAvailable = true;
                }

                averageRating = Math.round(averageRating * 10) / 10;
      
                product.avgRatings = averageRating;
                product.totalReviews = ratingNumbers;
      
                // Create custom star rating HTML
                const starContainer = document.createElement("div");
                starContainer.className = "areviews_rating";
                starContainer.style.marginTop = "5px";
                // starContainer.style.display = "flex";
                // starContainer.style.gap = "1px";
                // starContainer.style.flexWrap = 'wrap'

      
                let remaining = averageRating;
                for (let i = 0; i < 5; i++) {
                  const star = document.createElement("i");
                  star.style.marginLeft = "2px";
                  star.style.display = "inline-block";
                  star.style.color = "#f3c621";
      
                  if (remaining >= 1) {
                    star.className = "fas fa-star"; // full star
                  } else if (remaining >= 0.25) {
                    star.className = "fas fa-star-half-alt"; // half star
                  } else {
                    star.className = "far fa-star"; // empty star
                  }
      
                  remaining -= 1;
                  starContainer.appendChild(star);
                }
      
                // Add review count text
                const reviewText = document.createElement("span");
                reviewText.textContent = ` ${ratingNumbers} reviews`;
                starContainer.appendChild(document.createTextNode(` `));
                starContainer.appendChild(document.createTextNode(` ${averageRating} (`));
                starContainer.appendChild(reviewText);
                starContainer.appendChild(document.createTextNode(`)`));
      
                // Append starContainer to product or wherever needed
                const reviewWrapper = document.createElement("div");
                reviewWrapper.className = `areviews_product_item areviews_stars${product.id}`;
                reviewWrapper.setAttribute("data-product-id", product.id);
                reviewWrapper.appendChild(starContainer);
      
                // Save or display the final HTML element as needed
                product.renderedReviewElement = reviewWrapper.innerHTML;
                // console.log(product.renderedReviewElement,"product reviewWrapper")
              }
            }
          });
        }
      });


      
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (payload) {
      // console.log(payload, "BEFORE_AUTOCOMPLETE_EXECUTED");
      payload.minQueryLength = 1;
      return payload;
    }
  );

    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER, function(data) {
      // console.log(data, "<====BEFORE_AUTOCOMPLETE_RENDER");
      return data;
    })

     window.wizzyConfig.events.registerEvent(
      window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
      function (payload) {
        // console.log(payload,"BEFORE_AUTOCOMPLETE_EXECUTED")
        return payload;
      }
    );

   window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (payload) {
      // console.log(payload,"BEFORE_SEARCH_EXECUTED")
      return payload;
    }
  );

     window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (payload) {
      // console.log(payload.filters,"BEFORE_FILTERS_EXECUTED");      
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      // console.log(data," <= VIEW_RENDERED");
      
      return data;
    }
  );

   window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (payload) {
      // console.log(payload,"BEFORE_RENDER_RESULTS");
    
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
    function (payload) {
      return payload;
    }
  );
};

// Declaration of template replace function
const replaceTemplate = (div) => {
  let newDiv = document.getElementById(div + "-new").text;
  let oldDiv = document.getElementById(div);
  oldDiv.text = newDiv;
};

////////////////////////////////////////

window.addEventListener('scroll', function() {
  if (document.body) { // Check if the body exists
    const scrollPosition = window.scrollY || document.documentElement.scrollTop;
    const documentHeight = document.documentElement.scrollHeight - window.innerHeight;
    const scrollPercentage = (scrollPosition / documentHeight) * 100;

    if (scrollPercentage >= 1) {
      document.body.classList.add('wizzy-scrolled'); // Add your class here
    } else {
      document.body.classList.remove('wizzy-scrolled'); // Optionally, remove class when scrolling back above 1%
    }
  }
});

/////////////////////////////

if(window.document.documentElement.clientWidth < 768) {
  const wizzySearchInput = document.querySelector('.wizzy-search-input-mobile');
  function handleClick() {
    wizzySearchInput.focus();
    wizzySearchInput.click();
    console.log('Input clicked');
    wizzySearchInput.removeEventListener('click', handleClick);
  }
  wizzySearchInput.addEventListener('click', handleClick);
}


// MUTATION OBSERVER 1 //////////////////////////////////
function isDesktopWidth() {
    return window.innerWidth >= 1024; 
}

function setPositions() {
    if (isDesktopWidth()) {
        const targetElement = document.querySelector('.wizzy-overlay-opened.wizzy-filters-overlay .wizzy-search-wrapper.has-facets-in-drawer.facets-drawer-on-left .wizzy-search-results-wrapper .wizzy-search-filters-left .wizzy-search-filters-left-wrapper');

        const element = document.querySelector('.wizzy-search-wrapper .wizzy-filters-desktop-entry');

        const rect = element.getBoundingClientRect();
        const topPosition = rect.top;
        const leftPosition = rect.left;

        targetElement.style.top = `${topPosition+40}px`;
        targetElement.style.left = `${leftPosition+0}px`;
    }
}

const observerConfig = { attributes: true, subtree: true, attributeFilter: ['class'] };

const observerCallback = function(mutationsList, observer) {
    mutationsList.forEach(mutation => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
            if (document.body.classList.contains('wizzy-filters-overlay') && isDesktopWidth()) {
                setPositions();
            }
        }
    });
};

const observer = new MutationObserver(observerCallback);

observer.observe(document.body, observerConfig);


// MUTATION OBSERVER 2 //////////////////////////////////

if(window.document.documentElement.clientWidth < 768){
  let currentTarget = null;
  let observerAutocomplete = null;
  
  const startObserving = (target) => {
    currentTarget = target;
  
    const updateBodyClass = () => {
      const display = getComputedStyle(currentTarget).display;
      // console.log(display, "Wizzy display");
      if (display === 'flex') {
        document.body.classList.add('wizzy-autocomplete-opened');
      } else if (display === 'none') {
        document.body.classList.remove('wizzy-autocomplete-opened');
      }
    };
  
    updateBodyClass(); // Run once at start
  
    observerAutocomplete = new MutationObserver(() => {
      updateBodyClass();
    });
  
    observerAutocomplete.observe(currentTarget, {
      attributes: true,
      attributeFilter: ['style', 'class']
    });
  };
  
  const checkElement = setInterval(() => {
    const target = document.querySelector('.wizzy-autocomplete-wrapper');
    if (target && target !== currentTarget) {
      // console.log("I got the element or it changed");
      
      if (observerAutocomplete) {
        observerAutocomplete.disconnect(); // stop observing old element
      }
  
      startObserving(target);
    }
  }, 300);
}
